// extracted by mini-css-extract-plugin
export default {"main":"AYqQqrZkTU2d8Q8Vb8LEYA==","separator":"_5DK10rlghd6-65iXS6TSrw=="};